import React, { useState } from "react";
import PropTypes from "prop-types"; // Import PropTypes for type checkingames
import Popup from "reactjs-popup";
import { cn } from "../../utils/utils";
import WithdrawAuth from "../../components/withdraws/WithdrawAuth";

const ConfirmMoneyTransfer = ({ children, className }) => {
  const [showTooltip, setShowTooltip] = useState(
    localStorage.getItem("tooltip") === "open"
  );

  const handleTooltip = (e) => {
    localStorage.setItem("tooltip", "open");
    setShowTooltip(true);
    e.stopPropagation();
  };

  return (
    <Popup
      trigger={<button className={cn("", className)}>{children}</button>}
      onOpen={handleTooltip}
      onClose={() => {
        localStorage.setItem("tooltip", "close");
        localStorage.setItem("withdrawAuthCode", "");
      }}
      open={showTooltip}
      modal
      nested
    >
      {(close) => <WithdrawAuth close={close} />}
    </Popup>
  );
};

// PropTypes to validate props
ConfirmMoneyTransfer.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  refetch: PropTypes.func, // Optional refetch function
};

export default ConfirmMoneyTransfer;
